/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from "react";
import * as yup from "yup";
import {
    Formik,
    FormikProps,
    Form,
    Field,
    ErrorMessage,
    FormikActions,
} from "formik";
import { toast } from "react-toastify";
import { Spinner } from "../components/spinner";
import { FormikErrorMessage } from "../components/formik-error-message";
import { WebLayout } from "../components/web-layout";
import { API } from "../../utils/AxiosInstance";

interface State {
    email: string;
    password: string;
    confirm_password: string;
}

export function JotformSignUp() {
    const [errors, setErrors] = useState<string | undefined>(undefined);
    const schema = yup.object().shape({
        email: yup.string().email().required("is required"),
        password: yup
            .string()
            .min(8, "has to be equal or longer than 8 characters!")
            .required("is required"),
        confirm_password: yup
            .string()
            .test(
                "match",
                "password do not match",
                (confirm_password, testContext) =>
                    confirm_password === testContext.parent.password
            )
            .required("is required"),
    });

    const formikInitialValues: State = {
        email: "",
        password: "",
        confirm_password: "",
    };

    const onSubmit = async (values: State, actions: FormikActions<any>) => {
        try {
            const response = await API.post(`/register_jotform`, values);
            const { token } = response.data;
            if (token !== "") {
                localStorage.setItem("token", response.data.token as string);
                window.location.href = "/app/dashboard";
            } else {
                window.location.href = "/registered";
            }
            actions.setSubmitting(false);
        } catch (error: any) {
            actions.setSubmitting(false);
            if (error.data && error.data.message) {
                actions.setErrors(
                    (error.data.errors as Record<string, string>) || {}
                );
                setErrors(error.data.message as string);
            } else {
                toast.error((error as Error)?.message || "An error occurred");
            }
        }
    };

    return (
        <WebLayout>
            <Formik
                initialValues={formikInitialValues}
                onSubmit={onSubmit}
                validationSchema={schema}
                render={(formikProps: FormikProps<State>) => (
                    <Form
                        placeholder={undefined}
                        onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}
                    >
                        <div className="pb-4">
                            <Field
                                type="email"
                                name="email"
                                placeholder="Email"
                                className="form-control"
                                value={formikProps.values.email}
                            />
                            <ErrorMessage
                                name="email"
                                component={FormikErrorMessage}
                            />
                        </div>
                        <div className="pb-4">
                            <Field
                                type="password"
                                name="password"
                                placeholder="Password"
                                className="form-control"
                            />
                            <i className="text-xs">
                                Must contain a letter, a number and a symbol. It
                                must be at least 8 characters long.
                            </i>
                            <ErrorMessage
                                name="password"
                                component={FormikErrorMessage}
                            />
                        </div>
                        <div className="pb-4">
                            <Field
                                type="password"
                                name="confirm_password"
                                placeholder="Retype Password"
                                className="form-control"
                            />
                            <ErrorMessage
                                name="confirm_password"
                                component={FormikErrorMessage}
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-success form-control"
                            disabled={formikProps.isSubmitting}
                        >
                            {" "}
                            {formikProps.isSubmitting && <Spinner />} REGISTER
                            NOW!
                        </button>
                    </Form>
                )}
            />
            {errors ? <span className="color-red">{errors}</span> : null}
        </WebLayout>
    );
}
